import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as constants from '../constants/constants';
import { AuthContext } from '../contexts/AuthContext';

function NotFound() {
    const navigate = useNavigate();
    const { userData } = useContext(AuthContext);
    const token = userData?.token;

    useEffect(() => {
        if (!token) {
            navigate(constants.HOME);
        }
    }, [token, navigate]);

    if (!token) {
        return null; // Mientras redirecciona, no muestra nada
    }

    return (
        <div className="auteco_not-found">
            <div className="error-code">404</div>
            <div className="error-message">¡Ups!, algo no ha ido bien</div>
            <div className="error-description">No podemos encontrar la página que buscas.</div>
            <div className='button'>
                <div className="auteco_button primary" onClick={() => navigate(constants.HOME)}>Ir al inicio</div>
            </div>
        </div>
    );
}

export default NotFound;
